import { PersonDto } from './personDto'
import * as yup from 'yup'

export class BondPolicyNumberDto {
  bondPolicyNumberGuid?: string = undefined
  blockStart?: number = undefined
  blockEnd?: number = undefined
  remainingQuantity?: number = undefined
  createdBy?: PersonDto = undefined
  createdDateTime?: string = undefined
}

export const bondPolicyNumberValidationSchema = yup.object({
  blockStart: yup.number().min(0, 'Start cannot be less than 0.').required('Start is required.'),
  blockEnd: yup
    .number()
    .moreThan(yup.ref('blockStart'), 'End cannot be less than or equal to Start.')
    .required('End is required.')
})
